module.exports = __webpack_public_path__ + "img/bootstrap-4.2381de4f.png";